// Lib
import React, { ReactElement } from 'react';

// Components
import MobileTextStyleRichTextSheet from '../../../../mobile/toolbar/tools/richTextTool/MobileTextStyleRichTextSheet';
import MobileTableTextStyleSheetContent from './MobileTableTextStyleSheetContent';
import { SheetId } from '../../../../mobile/structural/sheet/sheetTypes';

// Types
import type { MobileTextStyleRichTextSheetProps } from '../../../../mobile/toolbar/tools/richTextTool/MobileTextStyleRichTextSheet';

/**
 * Renders the mobile text style tool for selected table cells.
 */
const MobileTableTextStyleRichTextTool: React.FC<MobileTextStyleRichTextSheetProps> = (props): ReactElement => {
    return (
        <MobileTextStyleRichTextSheet
            {...props}
            sheetId={SheetId.TableTextStyleRichTextTool}
            SheetContentComponent={MobileTableTextStyleSheetContent}
        />
    );
};

export default MobileTableTextStyleRichTextTool;
